<template>
  <StackPageLayout @close="navigateToMoreMenu">
    <template #header>
      <div class="flex w-full items-center justify-between">
        <PageTitle>Z Reports</PageTitle>
        <BaseDatePickerDrawer v-model="dateFilter" />
      </div>
    </template>

    <div v-if="reportsGroupedByDate.size > 0" class="mb-3">
      <template
        v-for="(
          [date, reports], idx
        ) in reportsGroupedByDate"
        :key="date"
      >
        <div
          :class="[
            'cursor-pointer px-2 pb-3 text-sm',
            idx === 0 ? '' : 'pt-3',
          ]"
        >
          {{ date }}
        </div>
        <ol
          class="-mx-4 mb-6 space-y-px bg-background-fg/10 py-px"
        >
          <li v-for="report in reports" :key="report.id">
            <ZReportListItem
              :report="report"
              @click="onClickZReport(report.id)"
            />
          </li>
        </ol>
      </template>
    </div>

    <div
      v-else
      class="py-16 text-center text-sm text-background-fg/60"
    >
      <p>No Z reports found.</p>
    </div>

    <div class="flex justify-around px-6">
      <BasePagination
        v-model:page="page"
        :page-count="pageCount"
      />
    </div>
  </StackPageLayout>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router"

import {
  type ListZReportsFilter,
  type ListZReportsResponseItem,
  useZReports,
} from "@/services/reconciliation/listZReports"

const router = useRouter()

const dateFilter = ref<string | null>(null)

const filters = computed<ListZReportsFilter>(() => ({
  reportDate: dateFilter.value,
}))

const {
  paginationQuery,
  page,
  pageCount,
  resetPagination,
} = usePagination({
  limit: 10,
  count: computed(() => data.value?.count || 0),
})

watch(
  () => filters.value,
  () => resetPagination(),
  { deep: true, immediate: true }
)

const query = computed(() => ({
  ...filters.value,
  ...paginationQuery.value,
}))

const { data } = useZReports(query)

const reportsGroupedByDate = computed(() => {
  if (!data.value)
    return new Map<string, ListZReportsResponseItem[]>()
  return data.value.items.reduce((map, report) => {
    const day = formatToDate(report.createdAt)
    const arr = map.get(day) ?? []
    arr.push(report)
    map.set(day, arr)
    return map
  }, new Map<string, ListZReportsResponseItem[]>())
})

const navigateToMoreMenu = () => {
  router.push({ name: "moreMenu" })
}

const onClickZReport = (id: string) => {
  router.push({
    name: "settingsZReportDetail",
    params: { zReportId: id },
    state: {
      backRoute: { name: "settingsZReportHistory" },
    },
  })
}
</script>
